import React from 'react';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Check';
import RemoveIcon from '@mui/icons-material/Remove';

import { FieldTableType, ActionType } from 'src/components/master/TypeCustom';
import { formatNumber, getField } from 'src/common/helper';
import { statuses } from 'src/components/master/Common';

import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
import Stack from '@mui/material/Stack';

const widthBtn = {
  minWidth: '60px',
  width: '60px',
};

type RecordItemProps = {
  item: any;
  fields: FieldTableType[];
  index?: number;
  onClickRow?: (data: any | undefined) => void;
  onClickButton?: (data: any | undefined, action?: ActionType) => void;
};

const RecordItem: React.FC<RecordItemProps> = (props) => {
  const getStatus = (id: string | null) => {
    const statusFind = statuses.find((item) => item.id === id);

    return statusFind ? statusFind.name : '-';
  };

  const getCell = (index: number, field: FieldTableType) => {
    switch (field.isColFinal) {
      case 'surgery': {
        return (
          <TableCell
            key={index}
            component='td'
            scope='row'
            sx={{ cursor: 'pointer' }}
            align={field.align}
          >
            <BtnGradient
              text={
                getField(props.item, field.field, 0) === 0 ? '詳細' : '詳細＊'
              }
              handleButtonClick={() => {
                props.onClickButton?.(props.item);
              }}
            />
          </TableCell>
        );
      }
      case 'product': {
        return (
          <TableCell
            key={index}
            component='td'
            scope='row'
            sx={{ cursor: 'pointer' }}
            align={field.align}
          >
            {getField(props.item, field.field, '0') === '0' ? (
              <RemoveIcon width={'20px'} height={'20px'} />
            ) : (
              <CheckIcon width={'20px'} height={'20px'} />
            )}
          </TableCell>
        );
      }
      case 'part': {
        return (
          <TableCell
            key={index}
            component='td'
            scope='row'
            sx={{ cursor: 'pointer' }}
            align={field.align}
          >
            <BtnOutlineGradient
              text='削除'
              handleButtonClick={() => {
                props.onClickButton?.(props.item);
              }}
              sxText={{
                background: '#DA4453',
              }}
              sx={{
                width: '60px',
                background: '#DA4453',
              }}
              sxButton={{
                minWidth: '56px',
              }}
            />
          </TableCell>
        );
      }
      case 'template-quote': {
        return (
          <TableCell
            key={index}
            component='td'
            scope='row'
            sx={{ cursor: 'pointer' }}
            align={field.align}
          >
            <Stack direction={'row'} spacing={'10px'}>
              <BtnGradient
                text={'コピー'}
                handleButtonClick={() => {
                  props.onClickButton?.(props.item, 'copy');
                }}
                sx={{
                  ...widthBtn,
                  background: '#26a69a',
                  '&:hover': { opacity: 0.8, bgcolor: '#0d776dd9' },
                }}
              />
              <BtnGradient
                text={'削除'}
                handleButtonClick={() => {
                  props.onClickButton?.(props.item, 'delete');
                }}
                sx={{
                  ...widthBtn,
                  background: '#DA4453',
                  '&:hover': { opacity: 0.8, bgcolor: '#a70c0cf2' },
                }}
              />
            </Stack>
          </TableCell>
        );
      }
      default:
        break;
    }
  };

  const handleClickRow = (
    event: React.MouseEvent<HTMLTableRowElement, MouseEvent>
  ) => {
    const target = event.target as HTMLElement;
    const isDropdownOrButton =
      target.closest('td')?.querySelector('.MuiOutlinedInput-root') ||
      target.closest('.MuiPopover-root') ||
      target.closest('td')?.querySelector('.MuiButtonBase-root');

    if (!isDropdownOrButton) {
      props.onClickRow?.(props.item);
    }
  };

  return (
    <TableRow
      hover
      onClick={handleClickRow}
      key={props.item.id}
      sx={{
        '&:last-child td, &:last-child th': { border: 0 },
        '& .MuiTableCell-root.MuiTableCell-body': {
          py: '4px',
          borderBottom: '1px solid #F3F3F3',
          fontSize: '12px',
          fontWeight: 400,
          lineHeight: '14.4px',
        },
        height: '48px',
      }}
    >
      {props.fields.map((field: FieldTableType, index: number) =>
        field.isColFinal ? (
          getCell(index, field)
        ) : (
          <TableCell
            key={index}
            component='td'
            scope='row'
            sx={{ cursor: 'pointer' }}
            align={field.align}
          >
            <Typography
              sx={{
                whiteSpace: 'pre-wrap',
                fontSize: '12px',
                fontWeight: 400,
                lineHeight: '14.4px',
              }}
            >
              {field.isPrice
                ? formatNumber(getField(props.item, field.field, 0))
                : field.isStatus
                ? getStatus(getField(props.item, field.field, '0'))
                : getField(props.item, field.field, '-')}
            </Typography>
          </TableCell>
        )
      )}
    </TableRow>
  );
};

export default RecordItem;
